import { FunctionComponent } from "react";
import ScrollableContainer from "../../../layout/scrollable-container";
import Flex from "../../../layout/flex";

interface LoadingScreenProps {
  loadingScreenMessage: string;
}

const LoadingScreen: FunctionComponent<LoadingScreenProps> = ({ loadingScreenMessage }: LoadingScreenProps) => {
  return (
    <ScrollableContainer name="loading-screen">
      <Flex $flexDirection="column" $justifyContent="center" $alignItems="center" $height="100%">
        {loadingScreenMessage || "Loading..."}
      </Flex>
    </ScrollableContainer>
  );
};

export default LoadingScreen;
